module.exports = __webpack_public_path__ + "img/478.f8687aab.jpg";